/**
 * Get instance of `_fwn.console` for internal use to log messages to.
 */
export const getFwnConsoleInstance = async () => {
  return typeof window !== 'undefined' && window._fwn?.console?.getInstance
    ? window._fwn?.console?.getInstance()
    : Promise.reject()
}
